<script lang="ts">
  /** Autosave chip for editing grids (OE-A21): saving → saved (+Undo) →
      idle, or a persistent error with Retry. */
  import { _ } from "svelte-i18n";
  import type { SaveTracker } from "$lib/saveTracker.svelte";

  let { tracker }: { tracker: SaveTracker } = $props();
</script>

{#if tracker.state !== "idle"}
  <div class="ss ss--{tracker.state}" role="status" aria-live="polite">
    {#if tracker.state === "saving"}
      <span class="material-icons-outlined ss-spin" aria-hidden="true">sync</span>
      {$_("common.saving")}
    {:else if tracker.state === "saved"}
      <span class="material-icons-outlined" aria-hidden="true">check_circle</span>
      <!-- Prices and access are saved from the same grid (2026-09-16). -->
      {$_("common.saved")}
      {#if tracker.undo}
        <button type="button" class="ss-btn" onclick={() => tracker.runUndo()}>
          {$_("common.undo")}
        </button>
      {/if}
    {:else}
      <span class="material-icons-outlined" aria-hidden="true">error_outline</span>
      {$_("common.saveFailed")}
      <button type="button" class="ss-btn" onclick={() => tracker.retry()}>
        {$_("common.retry")}
      </button>
    {/if}
  </div>
{/if}

<style>
  .ss {
    position: fixed;
    bottom: 24px;
    right: 24px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border-radius: 6px;
    font-size: 13px;
    color: #fff;
    background: #323232;
    z-index: 9999;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  }
  .ss--error { background: #b3261e; }
  .ss .material-icons-outlined { font-size: 17px; }
  .ss-spin { animation: ss-rot 1s linear infinite; }
  @keyframes ss-rot { to { transform: rotate(360deg); } }
  .ss-btn {
    background: rgba(255, 255, 255, 0.16);
    border: none;
    border-radius: 4px;
    color: #fff;
    font: inherit;
    font-weight: 600;
    padding: 3px 10px;
    cursor: pointer;
  }
  .ss-btn:hover { background: rgba(255, 255, 255, 0.28); }
</style>
